import { useNavigate } from 'react-router-dom';
import { HiMenu, HiLogout } from 'react-icons/hi';
import { useAuthStore } from '../../store/authStore';
import { useUIStore } from '../../store/uiStore';
import { Button } from '../ui/Button';

export function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const toggleSidebar = useUIStore((state) => state.toggleSidebar);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="flex items-center justify-between h-16 px-6 bg-white border-b border-gray-200">
      <button
        onClick={toggleSidebar}
        className="p-2 text-gray-500 hover:text-gray-700 lg:hidden"
      >
        <HiMenu className="w-6 h-6" />
      </button>

      <div className="flex-1" />

      <div className="flex items-center gap-4">
        <span className="text-sm text-gray-600">
          {user?.firstName} {user?.lastName}
        </span>
        <Button variant="ghost" size="sm" onClick={handleLogout} title="Logout">
          <HiLogout className="w-4 h-4" />
        </Button>
      </div>
    </header>
  );
}
